import Entities from "./shared/Entities";

export default class CountUp {
  constructor() {
    this.entities = new Entities("CountUp", "[data-counter-up]", CountUp.initSingle, CountUp.destroySingle);
  }

  static initSingle(containerEl) {
    const duration = 2000;
    const element = containerEl.querySelector("[data-counter-value]");

    if (!element) return;

    function onIntersect(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animate(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(onIntersect.bind(), {
      threshold: 0.6,
    });

    observer.observe(element);

    function animate(el) {
      const raw = el.getAttribute("data-counter-value").trim();

      const match = raw.match(/^([-+]?[0-9]*\.?[0-9]+)(.*)$/);
      if (!match) return;

      const numberStr = match[1];
      const suffix = match[2] || "";

      const number = parseFloat(numberStr);
      const decimalPlaces = (numberStr.split(",")[1] || "").length;

      const startTime = performance.now();

      const step = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = progress * number;

        const formatted = decimalPlaces > 0 ? parseFloat(current.toFixed(decimalPlaces)).toString() : Math.floor(current).toLocaleString();

        el.textContent = formatted + suffix;

        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = numberStr + suffix;
        }
      };

      requestAnimationFrame(step);
    }
  }

  static destroySingle({ entityObj }) {
    entityObj?.destroy();
  }
}
